var isMobileViewport = function isMobileViewport(viewport) {
  return viewport === "smallMobile" || viewport === "mediumMobile" || viewport === "largeMobile";
};

export default isMobileViewport;